import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Spin, Icon } from 'antd';

import PrItemTable from './PrItemTable';
import PoDetails   from './PoDetails';
import PrSummary   from './PrSummary';

const modalStyles = `
@keyframes prim-bar   { 0%{background-position:0% center} 100%{background-position:200% center} }
@keyframes prim-float { 0%,100%{transform:translateY(0px)} 50%{transform:translateY(-3px)} }
@keyframes prim-glow  { 0%,100%{box-shadow:0 0 0 0 rgba(24,144,255,0.4)} 50%{box-shadow:0 0 0 10px rgba(0,0,0,0)} }
@keyframes modal-pop  { from{opacity:0;transform:scale(0.96) translateY(12px)} to{opacity:1;transform:scale(1) translateY(0)} }

.prim-modal .ant-modal-content { border-radius:14px!important; overflow:hidden!important; box-shadow:0 24px 64px rgba(0,0,0,.16),0 0 0 1px rgba(24,144,255,.1)!important; animation:modal-pop .3s cubic-bezier(.22,1,.36,1) both!important; }
.prim-modal .ant-modal-header  { padding:0!important; border-bottom:none!important; }
.prim-modal .ant-modal-body    { padding:0!important; }
.prim-modal .ant-modal-footer  { display:none!important; }
.prim-modal .ant-modal-close   { top:14px!important; right:16px!important; color:rgba(255,255,255,0.8)!important; transition:color .2s,transform .2s!important; }
.prim-modal .ant-modal-close:hover { color:#fff!important; transform:rotate(90deg)!important; }
.prim-modal .ant-modal-close .ant-modal-close-x { width:36px!important; height:36px!important; line-height:36px!important; }

.prim-header { background:linear-gradient(135deg,#003a8c 0%,#0050b3 35%,#1890ff 70%,#096dd9 100%); padding:18px 22px 16px; display:flex; align-items:center; gap:14px; position:relative; overflow:hidden; }
.prim-header::before { content:''; position:absolute; inset:0; background-image:radial-gradient(rgba(255,255,255,.09) 1px,transparent 1px); background-size:20px 20px; pointer-events:none; }
.prim-header::after  { content:''; position:absolute; bottom:0; left:0; right:0; height:3px; background:linear-gradient(90deg,#13c2c2,#1890ff,#52c41a,#fa8c16,#13c2c2); background-size:300% auto; animation:prim-bar 3s linear infinite; }
.prim-header-icon { width:44px; height:44px; border-radius:12px; background:rgba(255,255,255,.15); border:1.5px solid rgba(255,255,255,.25); display:flex; align-items:center; justify-content:center; flex-shrink:0; animation:prim-glow 2.6s ease-in-out infinite, prim-float 3s ease-in-out infinite; }
.prim-header-title { font-size:15px; font-weight:800; color:#fff; letter-spacing:.8px; }
.prim-header-sub   { font-size:11px; color:rgba(255,255,255,.6); letter-spacing:1px; margin-top:2px; }

.prim-body { padding:20px 22px 24px; max-height:75vh; overflow-y:auto; }
.prim-body::-webkit-scrollbar { width:5px; }
.prim-body::-webkit-scrollbar-track { background:#f0f7ff; }
.prim-body::-webkit-scrollbar-thumb { background:#91d5ff; border-radius:4px; }

.prim-section { margin:16px 0 10px; display:flex; align-items:center; gap:6px; font-size:11px; font-weight:700; color:#1890ff; letter-spacing:1px; text-transform:uppercase; }
.prim-divider { flex:1; height:1px; background:linear-gradient(90deg,#d6e8ff,transparent); }

.prim-modal .ant-spin-dot-item { background:#1890ff!important; }
`;

const PrInformationModal = ({ visible, getSpoDetails, data, closeModal }) => {
  const [spin, setSpin] = useState(true);
  const [details, setDetails] = useState({
    spoItems:  [],
    poDetails: {},
    poItems:   [],
    poHistory: [],
  });

  useEffect(() => {
    setSpin(true);
    getSpoDetails(data.po_id)
      .then(res => { setDetails({ ...res }); setSpin(false); })
      .catch(() => setSpin(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { spoItems, poDetails, poItems, poHistory } = details;

  return (
    <>
      <style>{modalStyles}</style>
      <Modal
        className="prim-modal"
        visible={visible}
        footer={null}
        style={{ top: 20 }}
        width={1000}
        onCancel={() => closeModal('pr')}
        title={
          <div className="prim-header">
            <div className="prim-header-icon">
              <Icon type="file-text" style={{ fontSize: 20, color: '#fff' }} />
            </div>
            <div>
              <div className="prim-header-title">REQUEST DETAILS</div>
              <div className="prim-header-sub">Purchase Requisition Information</div>
            </div>
            <div style={{ marginLeft: 'auto' }}>
              <span style={{ display:'inline-flex', alignItems:'center', gap:5, background:'rgba(19,194,194,.2)', border:'1px solid rgba(19,194,194,.4)', borderRadius:20, padding:'3px 10px', fontSize:11, fontWeight:700, color:'#13c2c2', letterSpacing:'.5px' }}>
                <Icon type="profile" style={{ fontSize: 10 }} />
                PR DETAILS
              </span>
            </div>
          </div>
        }
      >
        <div className="prim-body">
          <Spin spinning={spin}>

            <PrSummary
              withExistingRm={poHistory.some(po =>
                po.joNumber.split(',').includes(data.joNum)
              )}
              prTotal={spoItems.reduce((acc, val) => acc + val.amount, 0)}
              itemTotalBudget={poItems
                .filter(item => item.isMatchItem)
                .reduce((acc, val) => acc + val.budgetPriceTotal, 0)}
            />

            <div className="prim-section">
              <Icon type="shopping-cart" />
              Purchase Order Items
              <div className="prim-divider" />
            </div>
            <PrItemTable prItems={spoItems} />

            <div className="prim-section">
              <Icon type="contacts" />
              Customer PO Details
              <div className="prim-divider" />
            </div>
            <PoDetails
              poDetails={poDetails}
              poItems={poItems}
              poHistory={poHistory}
            />

          </Spin>
        </div>
      </Modal>
    </>
  );
};

PrInformationModal.propTypes = {
  visible:       PropTypes.bool.isRequired,
  data:          PropTypes.objectOf(PropTypes.any).isRequired,
  closeModal:    PropTypes.func.isRequired,
  getSpoDetails: PropTypes.func.isRequired,
};

export default PrInformationModal;